import React from 'react'
import { Link } from 'react-router-dom'

import { getPlanLabel } from '../../const/orders'

export default class AuditPlanTable extends React.Component {
  render () {
    const { plans } = this.props
    return (
      <div className='table-responsive'>
        <table className='table'>
          <thead>
            <tr>
              <th>#</th>
              <th>Customer</th>
              <th>Order</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {plans.map((plan, id) => {
              return (
                <tr key={id}>
                  <td><Link to={`/orders/${plan.order.id}/plans/${plan.id}`}>{plan.order.number}.{plan.order.quotation.counter}</Link></td>
                  <td>{plan?.order?.customer?.name}</td>
                  <td><Link to={`/orders/${plan.order.id}`}>{plan.order.number}</Link></td>
                  <td>{getPlanLabel(plan.status)}</td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    )
  }
}
